<template>
    <div>
        <v-data-table v-if="items.length > 0" :items="items" :headers="headers">
            <template v-slot:item="props">
                <tr>
                    <td v-for="(header, index) in headers"
                        :key="index"
                        :class="propRequired(header.value,props.index)">
                        <span>{{ props.item[header.value] }}</span>
                    </td>
                </tr>
            </template>
            <!-- <template v-slot:item="{item}">
              <tr>
                <td>{{item.isDummy}}</td>
                <td>{{item.empCode}}</td>
                <td>{{item.lastName}}</td>
                <td>{{item.firstName}}</td>
                <td>{{item.middleName}}</td>
                <td>{{item.suffix}}</td>
                <td>{{item.nickName}}</td>
                <td>{{item.cAddress}}</td>
                <td>{{item.cAddressSubdivision}}</td>
                <td>{{item.cAddressTown}}</td>
                <td>{{item.city}}</td>
                <td>{{item.postalCode}}</td>
              </tr>
            </template>-->
        </v-data-table>
    </div>
</template>
<script>
    export default {
        props: {
            items: {
                default: () => [],
                type: Array
            },
            properties: {
                default: () => [],
                type: Array
            }
        },
        data: () => ({
            headers: [
                {
                    text: "Is Dummy",
                    value: "isDummy",
                    sortable: false
                },
                {
                    text: "EmpCode",
                    value: "empCode",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Address Key",
                    value: "formOfAddressKey",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Title",
                    value: "title",
                    sortable: false
                },
                {
                    text: "Last Name",
                    value: "lastName",
                    sortable: false
                },
                {
                    text: "First Name",
                    value: "firstName",
                    sortable: false
                },
                {
                    text: "Middle Name",
                    value: "middleName",
                    sortable: false
                },
                {
                    text: "Suffix",
                    value: "suffix",
                    sortable: false
                },
                /*RLV:22Aug2022*/
                {
                    text: "Middle Initial",
                    value: "middleInitial",
                    sortable: false
                },
                {
                    text: "Nick Name",
                    value: "nickName",
                    sortable: false
                },
                {
                    text: "No. and Street",
                    value: "cAddress",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                {
                    text: "Barangay or Subdivision",
                    value: "cAddressSubdivision",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                {
                    text: "City or Municipality",
                    value: "cAddressTown",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                {
                    text: "Province",
                    value: "city",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Region",
                    value: "cRegion",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Country",
                    value: "cCountry",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                {
                    text: "Zip Code",
                    value: "postalCode",
                    sortable: false,
                    class: "yellow lighten-2"
                },
                {
                    text: "No. and Street",
                    value: "pAddress",
                    sortable: false,
                    class: "green lighten-3"
                },
                {
                    text: "Barangay or Subdivision",
                    value: "pAddressSubdivision",
                    sortable: false,
                    class: "green lighten-3"
                },
                {
                    text: "City or Municipality",
                    value: "pAddressTown",
                    sortable: false,
                    class: "green lighten-3"
                },
                {
                    text: "Province",
                    value: "province",
                    sortable: false,
                    class: "green lighten-3"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Region",
                    value: "pRegion",
                    sortable: false,
                    class: "green lighten-3"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Country",
                    value: "pCountry",
                    sortable: false,
                    class: "green lighten-3"
                },
                {
                    text: "Zip Code",
                    value: "pZipCode",
                    sortable: false,
                    class: "green lighten-3"
                },
                {
                    text: "No. and Street",
                    value: "hAddress",
                    sortable: false,
                    class: "green lighten-2"
                },
                {
                    text: "Barangay or Subdivision",
                    value: "hAddressSubdivision",
                    sortable: false,
                    class: "green lighten-2"
                },
                {
                    text: "City or Municipality",
                    value: "hAddressTown",
                    sortable: false,
                    class: "green lighten-2"
                },
                {
                    text: "Province",
                    value: "hCity",
                    sortable: false,
                    class: "green lighten-2"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Region",
                    value: "hRegion",
                    sortable: false,
                    class: "green lighten-2"
                },
                /*RLV:30Jun2022*/
                {
                    text: "Country",
                    value: "hCountry",
                    sortable: false,
                    class: "green lighten-2"
                },
                {
                    text: "Zip Code",
                    value: "hZipCode",
                    sortable: false,
                    class: "green lighten-2"
                },
                {
                    text: "Citizenship",
                    value: "citizenship",
                    sortable: false
                },
                {
                    text: "Civil Status",
                    value: "civilStatus",
                    sortable: false
                },
                {
                    text: "Gender",
                    value: "gender",
                    sortable: false
                },
                {
                    text: "Weight",
                    value: "weight",
                    sortable: false
                },
                {
                    text: "Height",
                    value: "height",
                    sortable: false
                },
                {
                    text: "Religion",
                    value: "religion",
                    sortable: false
                },
                {
                    text: "Telephone No",
                    value: "telNo",
                    sortable: false
                },
                {
                    text: "Mobile No.",
                    value: "mobileNo",
                    sortable: false
                },
                {
                    text: "Email",
                    value: "email",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Company Email",
                    value: "compEmail",
                    sortable: false
                },
                {
                    text: "Birth Date",
                    value: "birthDate",
                    sortable: false
                },
                {
                    text: "Birth Place",
                    value: "birthPlace",
                    sortable: false
                },
                /*RLV:30Jun2022*/
                {
                    text: "Country of Birth",
                    value: "country",
                    sortable: false
                },
                {
                    text: "Blood Type",
                    value: "bloodType",
                    sortable: false
                },
                {
                    text: "Employee Status Code",
                    value: "empStatCode",
                    sortable: false
                },
                {
                    text: "Date Applied",
                    value: "dateApplied",
                    sortable: false
                },
                {
                    text: "Date Hired",
                    value: "dateHired",
                    sortable: false
                },
                {
                    text: "Probe Start",
                    value: "probeStart",
                    sortable: false
                },
                {
                    text: "Probe End",
                    value: "probeEnd",
                    sortable: false
                },
                {
                    text: "Date Regularized",
                    value: "dateRegularized",
                    sortable: false
                },
                {
                    text: "Date Resigned",
                    value: "dateResigned",
                    sortable: false
                },
                {
                    text: "End Contrat",
                    value: "endContract",
                    sortable: false
                },
                {
                    text: "TKGroupCode",
                    value: "tkGroupCode",
                    sortable: false
                },
                {
                    text: "Inactive",
                    value: "inactive",
                    sortable: false
                },
                {
                    text: "Is Applicant",
                    value: "isApplicant",
                    sortable: false
                },
                {
                    text: "Union Member",
                    value: "unionMember",
                    sortable: false
                },
                {
                    text: "Agency",
                    value: "agency",
                    sortable: false
                },
                {
                    text: "Contact Person Name",
                    value: "contactName",
                    sortable: false
                },
                {
                    text: "Contact Person Address",
                    value: "contactAddress",
                    sortable: false
                },
                {
                    text: "Relation to contact Person",
                    value: "contactRelation",
                    sortable: false
                },
                {
                    text: "Contact Person Tel No",
                    value: "contactTelNo",
                    sortable: false
                },
                {
                    text: "Confidential",
                    value: "confidential",
                    sortable: false
                },
                {
                    text: "Passport No.",
                    value: "passportNo",
                    sortable: false
                },
                {
                    text: "Passport Issued Date",
                    value: "passportIssuedDate",
                    sortable: false
                },
                {
                    text: "Passport Expiration Date",
                    value: "passportExpirationDate",
                    sortable: false
                },
                {
                    text: "Passport Remarks",
                    value: "passportRemarks",
                    sortable: false
                },
                {
                    text: "No. of Children",
                    value: "noOfChildren",
                    sortable: false
                },
                {
                    text: "Remarks",
                    value: "remarks",
                    sortable: false
                },
                {
                    text: "HRIS",
                    value: "hris",
                    sortable: false
                },
                {
                    text: "Payroll",
                    value: "payroll",
                    sortable: false
                },
                {
                    text: "TKS",
                    value: "tks",
                    sortable: false
                }
            ]
        }),
        computed: {},
        methods: {
            propRequired(prop, index) {
                var result = this.properties.filter(item => {
                    // console.log(item.property.toLowerCase());
                    // console.log(item.index);
                    return (
                        item.property.toLowerCase() == prop.toLowerCase() &&
                        item.index === index &&
                        item.mode == "MASTERFILE"
                    );
                });

                if (result.length > 0) return "red lighten-1";
                else return "";
            }
        }
    };
</script>
<style scoped>
    .header1 {
        background-color: red;
    }
</style>